export enum CustomFieldCaseCategories {
    Case = 1,
    Contact = 2,
    Reviews = 3,
    Staff = 4,
    Subject = 5
}